import React, { useState } from 'react';
import { List, Chip, Button, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery } from '@mui/material';
import CheckboxFacet from './CheckboxFacet/CheckboxFacet';
import styled from 'styled-components';
import FilterListIcon from '@mui/icons-material/FilterList';
import "./Facets.css";
import { Typography, Divider, IconButton   } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

export default function Facets(props) {
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    function mapFacetName(facetName) {
        const capitalizeFirstLetter = (string) =>
            string[0] ? `${string[0].toUpperCase()}${string.substring(1)}` : '';
        return capitalizeFirstLetter(facetName.trim().replace('_', ' '));
    }

    function addFilter(name, value) {
        const newFilters = props.filters.concat({ field: name, value: value });
        props.setFilters(newFilters);
    }

    function removeFilter(filter) {
        const newFilters = props.filters.filter((item) => item.value !== filter.value);
        props.setFilters(newFilters);
    }

    const facets = Object.keys(props.facets || {}).map(key => (
        <CheckboxFacet
            key={key}
            name={key}
            values={props.facets[key]}
            addFilter={addFilter}
            removeFilter={removeFilter}
            mapFacetName={mapFacetName}
            selectedFacets={props.filters.filter(f => f.field === key)}
        />
    ));

    const filters = props.filters.map((filter, index) => (
        <li key={index}>
            <Chip
                label={`${mapFacetName(filter.field)}: ${filter.value}`}
                onDelete={() => removeFilter(filter)}
                className="chip"
            />
        </li>
    ));

    const FilterContent = (
        <>
            <Divider sx={{ borderBottom: '1px solid #14143c', marginTop: '10px', marginX: 2 }} />
            <div className="facetbox">
                <div id="clearFilters">
                    <ul className="filterlist">{filters}</ul>
                </div>
                <FacetList component="nav" className="listitem">
                    {facets}
                </FacetList>
            </div>
        </>
    );

    return (
        <>
            {isMobile ? (
                <>
                        {/* <div id="clearFilters" style={{ padding: '0 15px' }}>
          <ul className="filterlist">{filters}</ul>
        </div> */}
  <IconButton
  onClick={() => setOpen(true)}
  sx={{
    color: '#14143C',
    padding: 0,
    margin: '10px 10px 10px 10px',
  }}
>
  <FilterListIcon sx={{ fontSize: '30px' }} />
</IconButton>
                    <Dialog   PaperProps={{
    sx: {
      width: '85%',
      maxWidth: '600px', // optional: to limit max width on large screens
      height: '1000px',
      margin: 'auto',
      borderRadius: 2,
    },
  }} open={open} onClose={() => setOpen(false)}>

<DialogTitle
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    color: '#14143C',
    fontWeight: 600,
    fontSize: '20px',
    position: 'relative', // Needed to position the close icon
    marginTop: '10px'
  }}
>
  <FilterListIcon sx={{ color: '#14143C' }} />
  Filters

  <IconButton
    aria-label="close"
    onClick={() => setOpen(false)}
    sx={{
      position: 'absolute',
      right: 15,
      top: 15,
      color: '#14143C',
    }}
  >
    <CloseIcon />
  </IconButton>
</DialogTitle>


  <DialogContent>
    {FilterContent}
  </DialogContent>

  <DialogActions sx={{ justifyContent: 'center', paddingBottom: 3 }}>
    <Button
      onClick={() => setOpen(false)}
      variant="contained"
      sx={{
        backgroundColor: '#14143C',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#1d1d4d', // darker shade for hover
        },
        fontWeight: 600,
        fontSize: isMobile ? '14px' : '20px',
      }}
    >
      Save
    </Button>
  </DialogActions>
</Dialog>
                </>
            ) : (
                <div id="facetPanel" className="box">
                    <div style={{ display: "flex", marginLeft: '20px' }}>
                        <FilterListIcon style={{ color: '#7b8193', fontSize: '28px' }} />
                        <Typography style={{ color: '#14143C', fontSize: '20px', marginLeft: '10px', fontWeight: '600' }}>
                            Filters
                        </Typography>
                    </div>
                    {FilterContent}
                </div>
            )}
        </>
    );
}

const FacetList = styled(List)({
    marginTop: '10px !important',
    fontFamily: 'Euclid Circular A, sans-serif',
    color: 'grey',
});
